import { render, staticRenderFns } from "./unsubscribe.vue?vue&type=template&id=bb681316&"
import script from "./unsubscribe.vue?vue&type=script&lang=js&"
export * from "./unsubscribe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports